import { UserInitialModalStep } from '@/types/common'
import { atom } from 'recoil'

export const interestModalVisibleState = atom<boolean>({
  key: 'interestModalVisibleState',
  default: false,
})

export const userInitialModalStepState = atom<UserInitialModalStep>({
  key: 'userInitialModalStepState',
  default: UserInitialModalStep.Profile,
})

export const userInitialModalVisibleState = atom<boolean>({
  key: 'userInitialModalVisibleState',
  default: false,
})

export const discoverLoginCheckInModalVisibleState = atom<boolean>({
  key: 'discoverLoginCheckInModalVisibleState',
  default: false,
})

export const discoverLoginCheckInModalDismissedState = atom<boolean>({
  key: 'discoverLoginCheckInModalDismissedState',
  default: false,
})

export const chatSettingModalVisibleState = atom<boolean>({
  key: 'chatSettingModalVisibleState',
  default: false,
})

export const conversationStyleModalVisibleState = atom<boolean>({
  key: 'conversationStyleModalVisibleState',
  default: false,
})

// Desktop Chat Bubble Style modal visibility
export const chatBubbleStyleModalVisibleState = atom<boolean>({
  key: 'chatBubbleStyleModalVisibleState',
  default: false,
})

export const chatModelSettingModalVisibleState = atom<boolean>({
  key: 'chatModelSettingModalVisibleState',
  default: false,
})

export const chatFeedbackModalVisibleState = atom<boolean>({
  key: 'chatFeedbackModalVisibleState',
  default: false,
})

export const mediaFeedbackModalVisibleState = atom<boolean>({
  key: 'mediaFeedbackModalVisibleState',
  default: false,
})

export const deleteChatConfirmDrawerVisibleState = atom<boolean>({
  key: 'deleteChatConfirmDrawerVisibleState',
  default: false,
})

export const deleteChatConfirmModalVisibleState = atom<boolean>({
  key: 'deleteChatConfirmModalVisibleState',
  default: false,
})

export const upgradeSubscriptionModalVisibleState = atom<boolean>({
  key: 'upgradeSubscriptionModalVisibleState',
  default: false,
})

export const benefitsChanges20241029ModelVisibleState = atom<boolean>({
  key: 'benefitsChanges20241029ModelVisibleState',
  default: false,
})

export const thanksGivingModalVisibleState = atom<boolean>({
  key: 'thanksGivingModalVisibleState',
  default: false,
})

export const downloadAppModelVisibleState = atom<boolean>({
  key: 'downloadAppModelVisibleState',
  default: false,
})

export const newUserModalVisibleState = atom<boolean>({
  key: 'newUserModalVisibleState',
  default: false,
})

export const christmasModalVisibleState = atom<boolean>({
  key: 'christmasModalVisibleState',
  default: false,
})

export const benefitsChanges20250110ModelVisibleState = atom<boolean>({
  key: 'benefitsChanges20250110ModelVisibleState',
  default: false,
})

export const benefitsChanges20250305ModelVisibleState = atom<boolean>({
  key: 'benefitsChanges20250305ModelVisibleState',
  default: false,
})

export const benefitsChanges20250329ModalVisibleState = atom<boolean>({
  key: 'benefitsChanges20250329ModalVisibleState',
  default: false,
})

export const reportCharacterModalVisibleState = atom<boolean>({
  key: 'reportCharacterModalVisibleState',
  default: false,
})

export const reportMessageModalVisibleState = atom<boolean>({
  key: 'reportMessageModalVisibleState',
  default: false,
})

export const annualPlanModalVisibleState = atom<boolean>({
  key: 'annualPlanModalVisibleState',
  default: false,
})

export const reportMediaModalVisibleState = atom<boolean>({
  key: 'reportMediaModalVisibleState',
  default: false,
})

export const selectCreateModalVisibleState = atom<boolean>({
  key: 'selectCreateModalVisibleState',
  default: false,
})

export const memoryLimitGuideOpen = atom<boolean>({
  key: 'memoryLimitGuideOpen',
  default: false,
})

export const memoryLimitGuideRedDotVisibleState = atom<boolean>({
  key: 'memoryLimitGuideRedDotVisibleState',
  default: false,
})

export const shareImgVideoModalVisibleState = atom<boolean>({
  key: 'shareImgVideoModalVisibleState',
  default: false,
})

export const linkAccountModalVisibleState = atom<boolean>({
  key: 'linkAccountModalVisibleState',
  default: false,
})
